import { Component, Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[pageCardItemContent]",
  standalone: false
})
export class PageCardItemContentComponent {
  constructor(public templateRef: TemplateRef<any>) {}
}
